import storage from "@/services/local-storage.service";

export function setStyleSheet(styleApp, styleBootstrap, styleCustom) {
        document.getElementById('styleSheetAppMin').setAttribute('href', styleApp);
        document.getElementById('styleSheetBootstrap').setAttribute('href', styleBootstrap);
        document.getElementById('styleSheetCustom').setAttribute('href', styleCustom);
        storage.add('styleSheetAppMin', styleApp);
        storage.add('styleSheetBootstrap', styleBootstrap);
        storage.add('styleSheetCustom', styleCustom);
}

export function getStyleSheet() {
    const styleSheetAppMin = <string>storage.get('styleSheetAppMin');
    const styleSheetBootstrap = <string>storage.get('styleSheetBootstrap');
    const styleSheetCustom = <string>storage.get('styleSheetCustom');
    if (styleSheetAppMin) {
        document.getElementById('styleSheetAppMin').setAttribute('href', styleSheetAppMin);
        document.getElementById('styleSheetBootstrap').setAttribute('href', styleSheetBootstrap);
        document.getElementById('styleSheetCustom').setAttribute('href', styleSheetCustom);
    }
}